import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import new_gif from '../../../../images/new_subs.gif';
import OrderPostpond from '../../../modal/Catering_Management/Manage_Catering/OrderPostpond';
import OrderCancelled from '../../../modal/Catering_Management/Manage_Catering/OrderCancelled';
import OrderPayment from '../../../modal/Catering_Management/Manage_Catering/OrderPayment';
import OrderConfirm from '../../../modal/Catering_Management/Manage_Catering/OrderConfirm';
import { toast } from 'react-toastify';
import axios from 'axios';
import Skeleton from "react-loading-skeleton"; 
import "react-loading-skeleton/dist/skeleton.css";

const ManageOrder = () => { 

    const tableRef = useRef(null);
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [cateringType, setCateringType] = useState([]);
    const [functionType, setFunctionType] = useState([]);
    const [orders, setOrders] = useState([]);
    const [mealsPeriod, setMealsPeriod] = useState([]);
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const ImgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    const [perPage, setPerPage] = useState(25);
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [datas, setDatas] = useState([]);
    const [total_entries, setTotalEntries] = useState(0);
    const [selectedOrder, setSelectedOrder] = React.useState(null);
    const whiteTextStatuses = [4, 5, 6, 7];
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    const handleOrderPostpond = (order) => {
        setSelectedOrder(order);
        setModalType("OrderPostpond");
        setOpen(true);
    };

    const closeModal = async () => {
        setOpen(false);
        setSelectedOrder(null);
        await fetchOrders();
    };

    const handleOrderCancelled = (order) => {
        setSelectedOrder(order);
        setModalType("OrderCancelled");
        setOpen(true);
    };

    const handleOrderPayment = (order) => {
        setSelectedOrder(order);
        setModalType("OrderPayment");
        setOpen(true);
    };

    const handleOrderConfirm = (order) => {
        setSelectedOrder(order);
        setModalType("OrderConfirm");
        setOpen(true);
    };

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const fetchOrders = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_order/list`, {
                params: { branch_id }
            });
            const data = response.data;
            setOrders(Array.isArray(data) ? data : []);
            setLoading(false);
        } catch (error) {
            setOrders([]);
            toast.error('Failed to fetch orders');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrders();
    }, []);

    const getOrderStatus = (status) => {
        const map = {
            "1": { label: "Ordered", bgColor: "#fff700", textColor: "black" },
            "2": { label: "Order Confirmed", bgColor: "#9ff551", textColor: "black" },
            "3": { label: "Order Postponed", bgColor: "#18bff1", textColor: "black" },
            "4": { label: "Order Cancelled", bgColor: "#ff1a1aba", textColor: "white" },
            "5": { label: "Payment Pending", bgColor: "#7e00afff", textColor: "white" },
            "6": { label: "Out For Delivery", bgColor: "#536ae3", textColor: "white" },
            "7": { label: "Delivered", bgColor: "#00812d", textColor: "white" },
            "8": { label: "Paid", bgColor: "#00812d", textColor: "white" },
            "9": { label: "Refund Initiated", bgColor: "#fff700", textColor: "black" },
            "10": { label: "Refunded", bgColor: "#536ae3", textColor: "white" },
        };

        return map[String(status)] || { label: "Unknown", bgColor: "#ccc", textColor: "black" };
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const fetchCateringType = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/cateringtype/getactive`);
            if (response.data && Array.isArray(response.data)) {
                const formatted = response.data.map(item => ({
                    value: String(item.sno),
                    label: item.catering_type
                }));
                setCateringType(formatted);
                console.log(formatted);
            }
        } catch (error) {
            console.error('Failed to fetch Catering Type:', error);
            setCateringType([]);
        }
    };

    const getCateringTypeLabel = (sno) => {
        if (!Array.isArray(cateringType)) return '';
        const found = cateringType.find(ct => ct.value === String(sno));
        return found?.label || '';
    };

    const fetchitemSchedule = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);

            const list = response.data?.data;

            if (Array.isArray(list)) {
                const formatted = list.map(item => ({
                    value: String(item.sno),
                    label: item.itemschedule_name
                }));
                setMealsPeriod(formatted);
            } else {
                setMealsPeriod([]); // fallback to empty array
            }
        } catch (error) {
            console.error('Failed to fetch Meals period:', error);
            setMealsPeriod([]); // fallback to empty array, not object
        }
    };

    const getMealsPeriodLabel = (sno) => {
        if (!Array.isArray(mealsPeriod)) return '';
        const found = mealsPeriod.find(mp => mp.value === String(sno));
        return found?.label || '';
    };

    const fetchFunctionType = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/functiontype/getactive`);
            if (response.data && Array.isArray(response.data)) {
                const formatted = response.data.map(item => ({
                    value: String(item.sno),
                    label: item.function_type
                }));
                setFunctionType(formatted);
            }
        } catch (error) {
            console.error('Failed to Function Type:', error);
            setFunctionType([]);
        }
    };

    const getFunctionTypeLabel = (sno) => {
        if (!Array.isArray(functionType)) return '';
        const found = functionType.find(ft => ft.value === String(sno));
        return found?.label || '';
    };

    const orderConfirm = async (order_id) => {
        try {
            const response = await axios.put(`${BaseUrl}/manage_order/update_order_status/${order_id}/2/0`);
            if (response) {
                toast.success('Order Confirmed');
                await fetchOrders();
            }
        } catch (error) {
            console.error('Failed to Confirm Order:', error);
        }
    };

    useEffect(() => {
        fetchFunctionType();
        fetchCateringType();
        fetchitemSchedule();
    }, []);

    const filteredOrders = useMemo(() => {
        if (!searchTerm) return orders;
        const lowerSearch = searchTerm.toLowerCase();

        return orders.filter(order => {
            const textToSearch =
                (order.catering_id || '') +
                (order.customer?.customer_name || '') +
                (order.customer?.customer_number || '') +
                (getFunctionTypeLabel(order.function_type) || '') +
                (getCateringTypeLabel(order.catering_type) || '') +
                (order.total?.toString() || '') +  // <-- added total here
                (order.order_date ? formatDate(order.order_date) : '') +
                (order.meals_period ? getMealsPeriodLabel(order.meals_period) : '') +
                (order.head_count?.toString() || '') +
                (order.payment_closing_date ? formatDate(order.payment_closing_date) : '') +
                (getOrderStatus(order.order_status)?.label || '');

            return textToSearch.toLowerCase().includes(lowerSearch);
        });
    }, [orders, searchTerm]);

    const totalPages = Math.ceil(filteredOrders.length / perPage);

    // Slice current page orders
    const currentOrders = useMemo(() => {
        const start = (page - 1) * perPage;
        return filteredOrders.slice(start, start + perPage);
    }, [filteredOrders, page, perPage]);

    const goToPage = (num) => {
        if (num < 1) setPage(1);
        else if (num > totalPages) setPage(totalPages);
        else setPage(num);
    };

    const downloadInvoiceDirect = (relativePath) => {
        if (!relativePath) {
            toast.error("Invoice path is missing.");
            return;
        }
        const fileUrl = `${ImgBaseUrl}/${relativePath.replace(/\\/g, '/')}`;
        window.open(fileUrl, '_blank'); // Opens in new tab
    };

    return (
        <>
            <style>
                {`
                    @keyframes zoomInOut {
                    0%, 100% {
                        transform: scale(1);
                        filter: drop-shadow(0 0 0px rgba(255, 0, 0, 0.5));
                    }
                        50% {
                            transform: scale(1.15);
                            filter: drop-shadow(0 0 8px rgba(245, 184, 184, 0.8));
                        }
                    }

                    .zoom-animation {
                        animation: zoomInOut 1.8s ease-in-out infinite;
                    }
                `}
            </style>

            {open && modalType === "OrderPostpond" && (
                <OrderPostpond
                    show={open}
                    onClose={closeModal}
                    order={selectedOrder}          // Pass order here
                />
            )}

            {open && modalType === "OrderCancelled" && (
                <OrderCancelled
                    show={open}
                    onClose={closeModal}
                    order={selectedOrder}
                />
            )}

            {open && modalType === "OrderPayment" && (
                <OrderPayment
                    show={open}
                    order={selectedOrder}
                    onClose={closeModal}
                />
            )}

            {open && modalType === "OrderConfirm" && (
                <OrderConfirm
                    show={open}
                    order={selectedOrder}
                    onClose={closeModal}
                    refresh={fetchOrders}
                />
            )}

            {loading ? (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Skeleton width={70} /></li>
                            <li className="breadcrumb-item"><Skeleton width={20} /></li>
                            <li className="breadcrumb-item active"><Skeleton width={100} /></li>
                        </ol>
                    </div>
                    <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                        <Skeleton width={30} height={30} borderRadius={12} />
                        <Skeleton width={100} />
                        <Skeleton width={30} height={30} borderRadius={12} />
                        <Skeleton width={100} />
                    </div>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                    <div className='mb-0'>
                        <div className="mb-0 px-0">
                            <h4 className='breadcrumb-header'>Manage Catering Orders</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Catering Management</li>
                        </ol>
                    </div>
                    <div className="d-flex flex-row align-items-center justify-content-between gap-2 bg-gray-300 border border-gray-700 py-2 px-2 rounded">
                        <div className="d-flex flex-row align-items-center justify-content-center gap-2">
                            <label className='py-3 px-3 rounded border border-gray-700' style={{ backgroundColor: '#ffb4aaff' }}></label>
                            <span>-</span>
                            <label className='text-black font-w600 fs-7'>Order Not Yet Confirmed</label>
                        </div>
                        <span>|</span>
                        <div className="d-flex flex-row align-items-center justify-content-center gap-2">
                            <label className='py-3 px-3 rounded border border-gray-700' style={{ backgroundColor: '#d0fff0' }}></label>
                            <span>-</span>
                            <label className='text-black font-w600 fs-7'>Payment Completed</label>
                        </div>
                    </div>
                </div>
            )}

            {loading ? (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2"><Skeleton width={50} height={25} /></label>
                            <Skeleton width={50} height={25} className="mb-1" />
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <Skeleton width={150} height={25} className="mb-1" />
                        </div>
                    </div>

                    <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                 <th><Skeleton width={100} height={16} /></th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {[...Array(perPage)].map((_, i) => (
                                <tr key={i}>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                     <td><Skeleton /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            <Skeleton width={180} height={15} />
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <div className="d-flex gap-2">
                                {[...Array(4)].map((_, i) => (
                                    <Skeleton key={i} width={40} height={25} borderRadius={5} />
                                ))}
                            </div>
                        </nav>
                    </div>
                </div>
            ) : (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Per page selector */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{ fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={e => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1);
                                }}
                            >
                                {[10, 25, 50, 100].map(size => (
                                    <option key={size} value={size}>
                                        {size}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Search box */}
                        <div>
                            <input
                                type="text"
                                style={{ fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={e => {
                                    setSearchTerm(e.target.value);
                                    setPage(1);
                                }}
                            />
                        </div>
                    </div>

                    <table
                        id="kt_datatable_responsive_approved"
                        className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
                        style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}
                    >
                        <thead>
                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className="min-w-100px">Order / Delivery Date</th>
                                <th className="min-w-80px">Customer / Mob No</th>
                                <th className="min-w-100px">
                                    <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement="bottom"
                                        overlay={
                                            <Tooltip className="toltip-popover">
                                                <span className="fs-8 text-white fw-semibold">Function Type</span>
                                            </Tooltip>
                                        }
                                    >
                                        <span>F Type</span>
                                    </OverlayTrigger>{' '}
                                    /{' '}
                                    <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement="bottom"
                                        overlay={
                                            <Tooltip className="toltip-popover">
                                                <span className="fs-8 text-white fw-semibold">Catering Type</span>
                                            </Tooltip>
                                        }
                                    >
                                        <span>C Type</span>
                                    </OverlayTrigger>{' '} 
                                </th>
                                 <th className="min-w-80px text-end">Ordered Amount</th>
                                <th className="min-w-50px text-center">
                                    <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement="bottom"
                                        overlay={
                                            <Tooltip className="toltip-popover">
                                                <span className="fs-8 text-white fw-semibold">Meals Period</span>
                                            </Tooltip>
                                        }
                                    >
                                        <span>MP</span>
                                    </OverlayTrigger>{' '}
                                    /{' '}
                                    <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement="bottom"
                                        overlay={
                                            <Tooltip className="toltip-popover">
                                                <span className="fs-8 text-white fw-semibold">Head Count</span>
                                            </Tooltip>
                                        }
                                    >
                                        <span>HC</span>
                                    </OverlayTrigger>{' '}
                                    /{' '}
                                    <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement="bottom"
                                        overlay={
                                            <Tooltip className="toltip-popover">
                                                <span className="fs-8 text-white fw-semibold">Payment Closing Date</span>
                                            </Tooltip>
                                        }
                                    >
                                        <span>PCD </span>
                                    </OverlayTrigger>
                                </th>
                                <th className="min-w-80px text-center">Order Status</th>
                                <th className="min-w-80px text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {currentOrders.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center p-3">
                                        No matching orders found.
                                    </td>
                                </tr>
                            )}
 
                            {currentOrders.map(order => ( 
                                <tr key={order.id} style={{ backgroundColor: order.order_status == 1 ? '#ffb4aaff' : order.order_status == 8 ? '#d0fff0' : '' }}>
                                    <td> 
                                        <div className="d-flex flex-column align-items-start">
                                            <div className="d-flex flex-row align-items-center">
                                                <label className="text-black font-w600 fs-7">{order.catering_id}</label>
                                                {new Date(order.created_at).toDateString() === new Date().toDateString() && (
                                                    <img src={new_gif} alt="New Lead" className="w-60px h-20px" />
                                                )}
                                            </div>
                                            <label className="text-primary font-w600 fs-7">{formatDate(order.order_date)}</label>
                                        </div>
                                    </td>

                                    <td> 
                                        <label className="text-black font-w600 fs-7">{order.customer?.customer_name}</label>
                                        <div className="d-block">
                                            <label className="text-primary font-w600 fs-7">{order.customer?.customer_number}</label>
                                        </div>
                                    </td>
 
                                    <td>
                                        <div className="d-flex flex-row align-items-center gap-2">
                                            <div>
                                                <label className="text-black font-w600 fs-7">{getFunctionTypeLabel(order.function_type)}</label>
                                                <div className="d-block">
                                                    <label className="text-primary font-w600 fs-7">
                                                        <label>{getCateringTypeLabel(order.catering_type)}</label>
                                                    </label>
                                                </div>
                                            </div> 
                                            
                                        </div>
                                    </td>
                             
                                    <td className="text-end">
                                    <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement="bottom"
                                        overlay={
                                        <Tooltip className="toltip-popover">
                                            <span className="fs-8 text-white fw-semibold">Total Amount</span>
                                        </Tooltip>
                                        }
                                    >
                                        <label className="text-danger border border-danger py-1 px-2 rounded font-w600 fs-7">
                                        ₹ {Number(order.total).toLocaleString('en-IN')}
                                        </label>
                                    </OverlayTrigger>
                                    </td>
                                    <td className="text-center">
                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                            <label className="text-black font-w600 fs-7">{getMealsPeriodLabel(order.meals_period)}</label>
                                            <Badge bg="info" className="py-0 px-2 fs-7">
                                                {order.head_count}
                                            </Badge>
                                        </div>
                                        <div className="d-block">
                                            <label className="text-primary font-w600 fs-7">{formatDate(order.payment_closing_date)}</label>
                                        </div>
                                    </td>

                                    <td className="text-center">
                                        <Dropdown drop="">
                                            <Dropdown.Toggle as="a" className={`i-false curson-pointer`}>
                                                <label
                                                    className={`py-1 px-2 rounded font-w600 fs-7 ${["1", "2", "5", "8"].includes(order.order_status) ? "cursor-pointer" : ""}`}
                                                    style={{
                                                        backgroundColor: getOrderStatus(order.order_status).bgColor,
                                                        color: getOrderStatus(order.order_status).textColor,
                                                    }}
                                                >
                                                    {getOrderStatus(order.order_status).label}
                                                </label>
                                            </Dropdown.Toggle>
                                            {order.order_status == 1 && (
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => handleOrderConfirm(order)} className="text-black">
                                                        Confirm
                                                    </Dropdown.Item> 
                                                    <Dropdown.Item onClick={() => handleOrderPostpond(order)} className="text-black">
                                                        Postpone
                                                    </Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleOrderCancelled(order)} className="text-black">
                                                        Cancel
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            )}

                                            {["2", "5", "8"].includes(order.order_status) && (
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => handleOrderCancelled(order)} className="text-black">
                                                        Cancel
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            )} 

                                            {order.order_status == 3 && (
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => handleOrderConfirm(order)} className="text-black">
                                                        Confirm
                                                    </Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleOrderCancelled(order)} className="text-black">
                                                        Cancel
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            )}
                                        </Dropdown>
                                        {order.order_status == 3 && (
                                            <div className='d-block'>
                                                <OverlayTrigger trigger="['hover','trigger']" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Order Postponed Date</span></Tooltip>} >
                                                    <label className='text-danger fs-7 font-w600'>{formatDate(order.order_postpone_date)}</label>
                                                </OverlayTrigger>
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        <span className="text-end">
                                            <div className='d-flex flex-row gap-2 align-items-center justify-content-end'>
                                                {order.total != order.paid_amount && order.order_status != 4 && order.order_status != 1 && order.order_status != 9 && order.order_status != 10 && (
                                                    <OverlayTrigger trigger="['hover','trigger']" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Pay</span></Tooltip>} >
                                                        <Button variant="primary tp-btn-light px-2 py-1 zoom-animation"
                                                            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '0.25rem 0.5rem', lineHeight: 1, height: '2px', border: 'none', backgroundColor: 'transparent', }} onClick={() => handleOrderPayment(order)}><span>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                                                                    <path fill="red" d="M17 3.34A10 10 0 1 1 2 12l.005-.324A10 10 0 0 1 17 3.34M15 7H9c-1.287 0-1.332 1.864-.133 1.993L9 9h1a2 2 0 0 1 1.732 1H9a1 1 0 0 0 0 2l2.732.001A2 2 0 0 1 10 13H9c-.89 0-1.337 1.077-.707 1.707l3 3a1 1 0 0 0 1.414 0l.083-.094a1 1 0 0 0-.083-1.32l-1.484-1.485l.113-.037a4.01 4.01 0 0 0 2.538-2.77L15 12a1 1 0 0 0 0-2h-1.126a4 4 0 0 0-.33-.855L13.465 9H15a1 1 0 0 0 1-1l-.007-.117A1 1 0 0 0 15 7" />
                                                                </svg>
                                                            </span>
                                                        </Button>
                                                    </OverlayTrigger>
                                                )}
                                     

                                                 {/* View */}
                                                        <Link
                                                        to="/catering-order-view"
                                                        state={{ order }}
                                                        className="cursor-pointer text-danger d-flex align-items-center"
                                                        >
                                                        <i className="fa-solid fa-eye fs-5 text-primary me-1"></i>
                                                        <span className="fs-7"></span>
                                                        </Link>

                                                        {/* Invoice (show only when conditions match) */}
                                                        {order.order_status != 1 && order.invoice != null && (
                                                        <span
                                                            onClick={() => downloadInvoiceDirect(order.invoice)}
                                                            className="cursor-pointer text-danger d-flex align-items-center"
                                                        >
                                                            <i className="fa-solid fa-file-alt fs-5 text-primary me-1"></i>
                                                            <span className="fs-7"></span>
                                                        </span>
                                                        )}

                                                        {/* Edit */}
                                                        <Link
                                                        to="/catering-order-edit"
                                                        state={{ order }}
                                                        className="cursor-pointer text-danger d-flex align-items-center"
                                                        >
                                                        <i className="fa-solid fa-edit fs-5 text-primary me-1"></i>
                                                        <span className="fs-7"></span>
                                                        </Link>

                                            </div>
                                        </span>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            {currentOrders.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + currentOrders.length} of {filteredOrders.length} entries
                                </span>
                            ) : (
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>
  
                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                {/* Previous Button */}
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                        Previous
                                    </button>
                                </li>

                                {/* First Page */}
                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                        1
                                    </button>
                                </li>

                                {/* Left Ellipsis */}
                                {page > 4 && (
                                    <li className="page-item disabled">
                                        <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                    </li>
                                )}

                                {/* Pages Around Current */}
                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                    .map(p => (
                                        <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                {p}
                                            </button>
                                        </li>
                                    ))}

                                {/* Right Ellipsis */}
                                {page < totalPages - 3 && (
                                    <li className="page-item disabled">
                                        <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                    </li>
                                )}

                                {/* Last Page */}
                                {totalPages > 1 && (
                                    <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                            {totalPages}
                                        </button>
                                    </li>
                                )}

                                {/* Next Button */}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>

                    </div>
                </div>
            )}

        </>
    )


}
export default ManageOrder;